import { PersonKeyRegular, PersonAccountsRegular, LockClosedKeyRegular } from '@fluentui/react-icons'
import { CapabilityCard } from '@/components/common/CapabilityCard'
import { PanelShell } from './PanelShell'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

export function IdentityPanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={PersonKeyRegular}
      title="Identity"
      subtitle="Identity risk, sign-ins, MFA and Conditional Access context from Microsoft Entra ID Protection."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.grid}>
        <CapabilityCard
          icon={PersonKeyRegular}
          eyebrow="Risk"
          title="Entra risky user context"
          points={['Identity Protection risk state', 'Risk detections tied to a user or sign-in']}
        />
        <CapabilityCard
          icon={PersonAccountsRegular}
          eyebrow="Activity"
          title="Sign-ins"
          points={['Sign-in location, device and application context', 'Anomalous sign-in patterns']}
        />
        <CapabilityCard
          icon={LockClosedKeyRegular}
          eyebrow="Controls"
          title="MFA & Conditional Access"
          points={['Multi-factor authentication status', 'Conditional Access policy context']}
        />
      </div>
    </PanelShell>
  )
}
